import React from 'react';
import { SquareLoader } from 'react-spinners';
import './Loader.scss';

const Loader = ({ size = 80, color = "#cda742" }) => {
  return (
    <div className="loader-container">
      <SquareLoader
        color={color}
        size={size}
        speedMultiplier={1}
      />
    </div>
  );
};

export default Loader; 